import {
    apiRequest,
    skcpnsCreate
} from '../../../../../services/adapters/kepegawaian/skcpnsService'

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", skcpnsCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository